import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Table, Modal,Image , Button} from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';

const SearchpageAdmin = () => {
    const [infoco, setInfoco] = useState([])
    const [id, setId] = useState('')
    const [num, setNum] = useState('0')
    const navigate = useNavigate()
    const {Id}= useParams()
    const authorization = localStorage.getItem("token")


    const [showsupprimer, setShowsupprimer] = useState(false);
    const handleClosesupprimer = () => setShowsupprimer(false);
    const handleShowsupprimer = (i) => {
        infoco.forEach(c =>
            c._id === i ? setId(c._id) : ''
        );


        setShowsupprimer(true);

    }
   const Delete = async () => {
    await axios.get(`${process.env.REACT_APP_API_URL}/commande/${id}/delete`, {
      headers: {
        'Authorization': `Bearer ${authorization}`
      }
    })
    setNum(num + 1)
    handleClosesupprimer()
  }
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/commande/${Id}/lister`, {
      headers: {
        'Authorization': `Bearer ${authorization}`
      }
    })
      .then(res => setInfoco(res.data))
      .catch(err => {
        if (err.response?.status === 404) {
          localStorage.clear()
          navigate('/login')
        }
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id,num])
    return (
        <div >
        {infoco.map((info, index) =>

            <ul className='borderr' key={info._id}>

                <h3 className='mt-5'>{index} - coordonneé de client: </h3>
                <li><b>Nom :</b>{info.nom}</li>
                <li><b>Prenom :</b>{info.prenom}</li>
                <li><b>Adresse :</b>{info.adresse}</li>
                <li><b>Numero :</b>{info.numero}</li>
                <li><b>Remarque :</b>{info.remarque}</li>
                <h3 className='mt-5'> Les achats de client :</h3>

                <Table variant="dark" striped bordered hover size="md" className='m-3' >
                    <thead>
                        <tr>
                            <th>image</th>
                            <th>Nom</th>
                            <th>Quantité</th>
                            <th>prix</th>

                        </tr>
                    </thead>
                    <tbody>

                        {info.article.map((infop, i) =>

                            <tr key={`${info._id}-${i}`}>
                                <td width={"250"} ><Image width="250"
                                    height="auto" src={infop.image} /></td>
                                <td>{infop.titre}</td>
                                <td>{infop.quantity}</td>
                                <td>{(infop.price || 0) * infop.quantity}</td>


                            </tr>



                        )
                        }




                    </tbody>
                </Table>
                <div className='prix_total'>
                    <h4 className='m-3 p-3 prix_t'>Prix total :    {info.article.map(item => (item.price || 0) * item.quantity).reduce((partialSum, a) => partialSum + a, 0)} TN</h4>

                    <Button variant='danger' className='m-3 height_button' onClick={() => handleShowsupprimer(info._id)}>    Supprimer la commande  </Button></div>
            </ul>


        )}




        <Modal show={showsupprimer} onHide={handleClosesupprimer} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>supprimer la commande</Modal.Title>
            </Modal.Header>
            <Modal.Body>Woohoo, are you sure to delete this commande ?</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClosesupprimer}>
                    Close
                </Button>
                <Button variant="primary" onClick={Delete}>
                    Supprimer la commande          </Button>
            </Modal.Footer>
        </Modal>

    </div>
    ) }



export default SearchpageAdmin